<template>

    <LoopItemPanel title="Kleur selecteren">

        <div class="canvas-blocks-sky-contentCardThumbnail-LoopItemPanel">

            <ColorsInput label="Card blok kleur"
                         instruction="Bepaal hier de achtergrondkleur van het blokje."
                         :colors="colors"
                         :options="loopItem"
                         options-property="color"
                         open="true"
                         @colorChange="save()"
            />

        </div>

    </LoopItemPanel>

</template>

<script>

import LoopItemPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/loop/LoopItemPanel";
import ColorsInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/ColorsInput";
import axios from "@galaxy/modules/Core/resources/js/axiosBuilder";

export default {

    extends: LoopItemPanel,

    components: {
        LoopItemPanel,
        ColorsInput,
    },

    data: function () {
        return {
            colors: null,
        }
    },

    mounted() {
        this.loadColors();
    },

    methods: {

        async loadColors() {
            // Grab database colors
            let databaseColors = (await axios.get('/galaxy/crud/'+ ($('html').data('prefix') !== undefined ? $('html').data('prefix') : 'admin/') +'form/ckeditor/database-colors/data')).data;

            // Initialize empty array
            this.colors = [
                'transparent',
                'white',
                'black',
            ];

            // Add colors from database to array
            $.each(databaseColors, (item, value) => {
                if (typeof value !== 'string') {
                    this.colors.push(...Object.values(value));
                } else {
                    this.colors.push(value);
                }
            })

            this.colors = _.uniq(this.colors);
        },

    },

}

</script>

<style lang="scss" scoped>

    .canvas-blocks-sky-contentCardThumbnail-LoopItemPanel {



    }

</style>
